import React from 'react';

class About extends React.Component {
  render() {
    return (
        <div>
          <h2 style={{ color: '#166088'}}>Senior Technology Manager</h2>
          <hr style={{ width: '75%', padding: '1em'}}/>
          <div style={{width: '100%'}} className={'text-center'}>Senior Technology Manager • Lead Technology Manager • Assoc. IT Director • IT Director<br />
            Reduced Costs • Increased Productivity • Project Management • Solution Integration • Help Desk<br />
            Infrastructure • Cloud Management • Systems Design • Automation • User Training</div>
        </div>
      );
  }
}

export default About;
